module.exports = __webpack_public_path__ + "static/img/7.5659245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/7.jpg
// module id = m2SN
// module chunks = 1